export default __webpack_public_path__ + "static/media/gallery_03.95141d0a.jpg";